import React from 'react';
import PropTypes from 'prop-types';

import SearchContainer from 'containers/SearchContainer';
import LocationListContainer from 'containers/LocationListContainer';
import MobileViewContainer from 'containers/MobileViewContainer';

import { locationsContainer, locationsContainerMobile } from 'constants/styles';

export default class LocationsContainer extends React.Component {
  render() {
    const {
      locations,
      googleMapURL,
      mapboxAccessToken,
      handleToggleClose,
      handleToggleOpen,
      revertToDefault,
      settings,
      updateCenter,
      updateSearchResults,
      updateZoom,
      locationNearby,
      chowNowId,
    } = this.props;
    return (
      <MobileViewContainer
        id="locationsContainer"
        styles={locationsContainer}
        mobileStyles={locationsContainerMobile}
      >
        {settings.displaySearch && (
          <SearchContainer
            locations={locations}
            googleMapURL={googleMapURL}
            mapboxAccessToken={mapboxAccessToken}
            revertToDefault={revertToDefault}
            updateCenter={updateCenter}
            updateSearchResults={updateSearchResults}
            updateZoom={updateZoom}
            locationNearby={locationNearby}
          />
        )}
        <LocationListContainer
          handleToggleClose={handleToggleClose}
          handleToggleOpen={handleToggleOpen}
          locations={locations}
          updateCenter={updateCenter}
          updateZoom={updateZoom}
          displayMoreInfo={settings.displayMoreInfo}
          displayMultiButton={settings.displayMultiButton}
          multiButton={settings.multiButton}
          chowNowId={chowNowId}
        />
      </MobileViewContainer>
    );
  }
}

LocationsContainer.propTypes = {
  chowNowId: PropTypes.string,
  googleMapURL: PropTypes.string.isRequired,
  mapboxAccessToken: PropTypes.string.isRequired,
  handleToggleClose: PropTypes.func.isRequired,
  handleToggleOpen: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  revertToDefault: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  updateCenter: PropTypes.func.isRequired,
  updateSearchResults: PropTypes.func.isRequired,
  updateZoom: PropTypes.func.isRequired,
  locationNearby: PropTypes.bool.isRequired,
};

LocationsContainer.defaultProps = {
  chowNowId: null,
  locations: [],
};
